import { useCallback, useState } from 'react';
import { useApi } from '@micromag/data';

// import useData from './useData';

const useStoryLock = (storyId) => {
    const [finding, setFinding] = useState(false);
    const api = useApi();
    const find = useCallback(() => {
        setFinding(true);
        return api.stories.locks
            .find(storyId)
            .then((response) => {
                setFinding(false);
                return response;
            })
            .catch(() => setFinding(false));
    }, [api, storyId, setFinding]);
    return {
        find,
        finding,
    };
};

export default useStoryLock;
